module.exports = __webpack_public_path__ + "static/media/checked.917c0754.svg";